import React from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { ThumbsUp, MessageSquare } from 'react-feather';
import useTranslation from 'next-translate/useTranslation';
import { TextBolder14 } from '../../VuexyDesign/atoms/Text';
import Flex from '../common/Flex';
import { DarkerDivider } from '../common/Dividers';
import { CommunityPostResponse } from '../../api/lib/api/musicKnowledgeHub';
import { convertThousandIntoKilo } from '../../utils/convertThousandIntoKilo';
import { style } from '../../api';

function TrendingPostCard({ postData }: { postData: CommunityPostResponse }) {
  const router = useRouter();
  const { t } = useTranslation('musicKnowledgeHub');
  return (
    <TrendingPostCardContainer
      className="p-1"
      key={`trend-post-list-${postData.title}-${postData.id}`}
    >
      <Flex
        mb="1rem"
        flexDirection="column"
        justifyContent="center"
        onClick={() => {
          router.push(`/music-knowledge-hub/${postData.slug}`);
        }}
        className="cursor-pointer"
      >
        <div className="style-posted-in">
          {t('musicKnowledgeHub:postedIn')}
          <span className="style-posted-in-subText font-weight-bolder">
            {postData.community.name}
          </span>
        </div>

        <div className="margin-description-trending-post">
          <TextBolder14 className="hover-pink">{postData.title}</TextBolder14>
        </div>
        <div className="d-flex align-items-center margin-description-trending-post">
          <div className="mr-1 d-flex align-items-center">
            <MessageSquare size={14} />
            <span className="font-size-value-icons style-posted-in-subText">
              {postData.total_comments}
            </span>
          </div>
          <div className=" d-flex align-items-start">
            <ThumbsUp size={14} />
            <span className="font-size-value-icons style-posted-in-subText">
              {convertThousandIntoKilo(postData.upvotes)}
            </span>
          </div>
        </div>
      </Flex>
      <DarkerDivider />
    </TrendingPostCardContainer>
  );
}

const TrendingPostCardContainer = styled.div`
  .hover-pink {
    :hover {
      color: ${style.primary_pink_new};
    }
  }
  .style-posted-in-subText {
    margin-left: 0.2rem;
  }
  .font-size-value-icons {
    font-size: 12px;
  }
  .style-posted-in {
    color: #000000;
    font-weight: 400;
    font-size: 12px;
    opacity: 0.7;
  }
  .margin-description-trending-post {
    margin-top: 0.5rem;
  }
`;

export default TrendingPostCard;
